<script setup lang="ts">

import { ref } from "vue";
import { WizardNavigation } from "./Types/WizardNavigation";
import { BookingViewModel } from "./BookingViewModel";

import Breadcrumbs from "./Components/Breadcrumbs.vue";
import Navigation from "./Components/Navigation.vue";

import ConfirmationPage from "./Pages/ConfirmationPage.vue";

const model = new BookingViewModel();
const navigation = ref( new WizardNavigation( 5, (finalize:Function) =>
{
    setTimeout( () =>
    {
        finalize();
    }, 2000 );
} ) );

</script>

<template>

    <div class="page-content p-0">
        <div class="flex flex-col items-center text-lg w-full h-full">

            <Breadcrumbs v-model="navigation" />

            <div class="flex-1 w-full">

                <TabPanels v-model="navigation.index" class="absolute w-full !h-full p-4">

                    <TabPanel class="w-full h-full"> 
                        Booking Page 3
                    </TabPanel>

                    <TabPanel class="w-full h-full"> 
                        Booking Page 4 - Final Step
                    </TabPanel>

                    <TabPanel class="w-full h-full"> 
                        <ConfirmationPage v-model="model" />
                    </TabPanel>

                </TabPanels>

            </div>

            <Navigation v-model="navigation" returnTo="/my-garage?p=bookings" />
            
        </div>
    </div>

</template>